module.exports = __webpack_public_path__ + "static/media/home-toplu-sms.29d352e0.png";